var SCROLL_DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
};
var TAB_ALIGNMENT = {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center'
};
var TAB_VARIANT = {
  DEFAULT: 'default',
  BOX: 'box-tab',
  BOX_LINE_TOP: 'box-tab-top-line',
  GREY: 'grey'
};

export { SCROLL_DIRECTION, TAB_ALIGNMENT, TAB_VARIANT };
